import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Link from "./Link";
import './_static/Navbar.css';
import './_static/Link.css';
import homeImage from '../_images/house-fill.svg';
import instrumentImage from '../_images/projector-fill.svg';
import demoImage from '../_images/rocket-takeoff-fill.svg';
import customerImage from '../_images/people-fill.svg';
import toolsImage from '../_images/tools.svg';
import repeatImage from '../_images/repeat.svg';
import settingsImage from '../_images/gear-fill.svg';
import administrationImage from '../_images/folder-fill.svg';
import loanImage from '../_images/hand.png';
import installImage from '../_images/install.svg';
import infoImage from '../_images/info.svg';
import qrScannerImage from '../_images/qr-scan.svg';
import {getAppName} from "../Api";

function Navigation() {

    const [displaySettings, setDisplaySettings] = React.useState(false)
    const [displayInstrumentSettings, setDisplayInstrumentSettings] = React.useState(false)
    const [displayServiceCaseSettings, setDisplayServiceCaseSettings] = React.useState(false)
    const [displayBTKSettings, setDisplayBTKSettings] = React.useState(false)
    const [displayLoanSettings, setDisplayLoanSettings] = React.useState(false)
    const [displayInstallationSettings, setDisplayInstallationSettings] = React.useState(false)
    const [displayAdministration, setDisplayAdministration] = React.useState(false)
    const [admin, setAdmin] = React.useState(false)

    // currentPath is used to determine which link is active
    const currentPath = window.location.pathname;

    function showSettings() {
        setDisplaySettings(!displaySettings)
    }


    function showInstrumentSettings() {
        setDisplayInstrumentSettings(!displayInstrumentSettings)
    }

    function showServiceCaseSettings() {
        setDisplayServiceCaseSettings(!displayServiceCaseSettings)
    }

    function showBTKSettings() {
        setDisplayBTKSettings(!displayBTKSettings)
    }


    function showLoanSettings() {
        setDisplayLoanSettings(!displayLoanSettings)
    }

    function showInstallationSettings() {
        setDisplayInstallationSettings(!displayInstallationSettings)
    }

    function showAdministration() {
        setDisplayAdministration(!displayAdministration)
    }

    function getAdmin() {
        // TO-DO: implement login properly
        const appName = getAppName()
        const isAdmin = localStorage.getItem(`${appName}_admin`)
        if (isAdmin === "true") {
            setAdmin(true)
        } else {
            setAdmin(false)
        }
    }

    React.useEffect(() => {
        getAdmin()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Navbar expand="lg" variant="light" className="navbarCustom">
            <Navbar.Toggle aria-controls="basic-navbar-nav"/>
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav activeKey={currentPath} className="flex-column navbarCustom">
                    <Link image={homeImage} link="/" label="Domov"/>
                    <Link image={instrumentImage} link="/instruments" label="Prístroje"/>
                    <Link image={demoImage} link="/instruments_demo" label="Demo Prístroje"/>
                    <Link image={customerImage} link="/companies" label="Zákazníci"/>
                    <Link image={installImage} link="/installations" label="Inštalácie"/>
                    <Link image={toolsImage} link="/service_cases" label="Servisné Prípady"/>
                    <Link image={repeatImage} link="/btks" label="BTK"/>
                    <Link image={loanImage} link="/loans" label="Zápožičky"/>
                    <Link image={qrScannerImage} link="/qr" label="QR Scan"/>
                    <a style={{cursor: 'pointer'}} data-rr-ui-event-key="/users" className="nav-link no-highlight"
                       onClick={showSettings}>
                        <img src={settingsImage} className="linkImage no-highlight" alt=""/>Nastavenia
                    </a>
                    {displaySettings && (
                        <Container>
                            <a style={{cursor: 'pointer'}} data-rr-ui-event-key="/users"
                               className="nav-link no-highlight"
                               onClick={showInstrumentSettings}>
                                Prístroje
                            </a>
                            {displayInstrumentSettings && (
                                <Container>
                                    <Link link="/manufacturers" label="Výrobcovia"/>
                                    <Link link="/instrument_states" label="Stavy Prístrojov"/>
                                    <Link link="/products" label="Produkty"/>
                                    <Link link="/product_groups" label="Produktové Skupiny"/>
                                </Container>
                                )}
                            <a style={{cursor: 'pointer'}} data-rr-ui-event-key="/users"
                               className="nav-link no-highlight"
                               onClick={showInstallationSettings}>
                                Inštalácie
                            </a>
                            {displayInstallationSettings && (
                                <Container>
                                    <Link link="/installation_states" label="Stavy Inštalácií"/>
                                </Container>
                            )}
                            <a style={{cursor: 'pointer'}} data-rr-ui-event-key="/users"
                               className="nav-link no-highlight"
                               onClick={showServiceCaseSettings}>
                                Servisné prípady
                            </a>
                            {displayServiceCaseSettings && (
                                <Container>
                                    <Link link="/service_case_state_categories" label="Kategórie Stavov"/>
                                    <Link link="/service_case_states" label="Stavy Servisných Prípadov"/>
                                    <Link link="/service_case_actions" label="Druhy Činnosti"/>
                                    <Link link="/service_case_types" label="Typy Servisu"/>
                                    <Link link="/service_case_regime_costs" label="Režijné Náklady"/>
                                    <Link link="/service_case_works" label="Vykonané Práce"/>
                                    <Link link="/service_case_spare_parts" label="Náhradné diely"/>
                                </Container>
                            )}
                            <a style={{cursor: 'pointer'}} data-rr-ui-event-key="/users"
                               className="nav-link no-highlight"
                               onClick={showBTKSettings}>
                                BTK
                            </a>
                            {displayBTKSettings && (
                                <Container>
                                    <Link link="/btk_states" label="Stavy BTK"/>
                                    <Link link="/btk_results" label="Vysledky Kontroly"/>
                                </Container>
                            )}
                            <a style={{cursor: 'pointer'}} data-rr-ui-event-key="/users"
                               className="nav-link no-highlight"
                               onClick={showLoanSettings}>
                                Zápožičky
                            </a>
                            {displayLoanSettings && (
                                <Container>
                                    <Link link="/loan_states" label="Stavy Zápožičiek"/>
                                    <Link link="/loan_types" label="Typy Zápožičiek"/>
                                </Container>
                            )}
                        </Container>
                    )}
                    {
                        admin && (
                            <a style={{cursor: 'pointer'}} data-rr-ui-event-key="/users" className="nav-link no-highlight"
                               onClick={showAdministration}>
                                <img src={administrationImage} className="linkImage no-highlight" alt=""/>Administrácia
                            </a>
                        )
                    }
                    {
                        displayAdministration && (
                            <Container>
                                <Link link="/users" label="Správa užívateľov"/>
                                <Link link="/company_setup/1" label="Údaje o firme"/>
                                <Link link="/pricelistLoader" label="Nahrať cenník"/>
                                <Link link="/configuration" label="Systémové nastavenia"/>
                            </Container>
                        )
                    }
                    <Link image={infoImage} link="/version_info" label="Verzie"/>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
}

export default Navigation;